import React, {Fragment, useEffect} from "react"
import { useNavigate } from "react-router-dom";
import ReactHtmlParser from 'react-html-parser';
import i18n from '../i18n';
import DefElement from "./DefElement";
import {Button} from "react-bootstrap";
import {Translation} from "react-i18next";
import SeamlessLoopPlayer from "./SeamlessLoopPlayer";
import {AUDIO_FILES} from "../constants";
import ToneJSLoopPlayer from "./ToneJSLoopPlayer";
import Accordion from 'react-bootstrap/Accordion';
import 'bootstrap/dist/css/bootstrap.min.css';
import Search from "./Search";

function withHooks(WrappedComponent) {
    return function(props) {
        const nav = useNavigate();
        return <WrappedComponent nav={nav} {...props}/>
    };
}

class Itom extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            'rem_cell': '',
            'text': '',
            'datum': '',
            audio: '',
            play_on: 0
        };
    }

    getItems = () => {
        const items = AUDIO_FILES.sort((a, b) => a.name.localeCompare(b.name)) ;
        console.log(items);
        return items.map((el, i, name, file, bpm, id) =>
            <ToneJSLoopPlayer elementData={el} key={i} items={items} file={file} bpm={bpm} id={id}/>);
    }

    playAudio = (e) => {
       // console.log(e.currentTarget.id,this.state.play_on);
        //this.setState(state => ({audio: new Audio(AUDIO_FILES[e.currentTarget.id])}));
        let audio = new Audio('/kolan-kolanych-loopcdf49bc3aa58642fd00857f3d38c44b7.wav');
        this.setState(state => ({audio: audio}));
        console.log(audio);
        audio.addEventListener('ended', () => {
            this.setState(state => ({play_on: 0}));
        })
        if(this.state.play_on === 0) {
            this.setState(state => ({play_on: 1}));
            let playPromise =
                audio.play()
            //this.setState(state => ({play_on: 0}));
            if (playPromise !== undefined) {
                playPromise.then(_ => {
                    //console.log(audio);
                    // Automatic playback started!
                    // Show playing UI.
                    // We can now safely pause video...
                    //this.state.audio.pause();

                })
                    .catch(error => {
                        console.log(playPromise);
                    });
            }
            else {
                audio.load();
                audio.play().then(r => {
                    this.setState(state => ({play_on: 0}));
                });
            }
        }
    }

    handleNickChange = (e) => {
        this.setState({name: e.target.value});
    };

    handleLangChange = (e) => {
        this.setState({lang: e.target.value});
        i18n.language = e.target.value;
       // console.log(i18n.language);
    };

    handleClick = (e) => {
        //https://api.roomab.art/get-events-by-datum?data=2002-02-05
        this.setState({datum: e.target.value});
        fetch('https://api.roomab.art/get-events-by-datum?data='+e.target.value)
            // fetch('https://api.roomab.art/'
            .then(response => response.json())
            .then(data => {
                //this.getAnswers(data)
                console.log(data)

                this.setState(state =>({
                    item_id: data.id,
                    text: data.text,
                    img: data.img
                }))
            });
    };

    randomNumberInRange = (min, max) => {
        const minCeiled = Math.ceil(min);
        const maxFloored = Math.floor(max);
        //console.log(minCeiled,maxFloored,Math.random());
        return Math.floor(Math.random() * (maxFloored - minCeiled + 1) + minCeiled);
        //return Math.floor(Math.random() * max);
    };

    getItem(id) {

        fetch('https://api.roomab.art/get-rand-bard-item')
            // fetch('https://api.roomab.art/'
            .then(response => response.json())
            .then(data => {
                //this.getAnswers(data)
                console.log(data)

                this.setState(state =>({
                    item_id: data.id,
                    title: data.title,
                    text: data.text,
                    audio: data.audio,
                    img: data.img
                }))
            });
    }

    componentDidMount() {

        /*
        this.getItem();
        const timeoutId = setTimeout(() => {
            window.location.reload();
        }, 40000);
        *
        fetch('https://api.roomab.art/get-rand-bard-items')
            .then(response => response.json())
            .then(data => {
                //this.getAnswers(data)
               // console.log(data)
                this.setState(state =>({rem_cell: data}))
                localStorage.setItem('rem_cell', JSON.stringify(data));
            });*/
    }

    handleRefresh = () => {

    };


    render() {
        return (
            <header className="App-header d-grid gap-2">
                <Accordion defaultActiveKey="0">
                        {this.getItems()}
                </Accordion>
            </header>
        );
    }
}
export default withHooks(Itom)
